import { Intervention } from '@agroone/entities'
import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core'
import { TranslatePipe, TranslateService } from '@ngx-translate/core'
import { DateWeekNumberDirective } from '../../../../directives/date-week-number.directive'
import { TranslateConstantPipe } from '../../../../pipes'
import { SharedConstantService } from '../../../../services'
import { InterventionFoodSafetyTypes } from '../../enums/intervention-foodsafety-types.enum'
import { NutrientsActivityTypePipe } from '../../pipes/nutrients-activity-type.pipe'

@Component({
  selector: 'nutrients',
  templateUrl: './nutrients.component.html',
  styleUrls: ['./nutrients.component.scss'],
  imports: [TranslateConstantPipe, TranslatePipe, DateWeekNumberDirective, NutrientsActivityTypePipe],
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class NutrientsComponent {
  readonly intervention = input.required<Intervention>()
  public constantService: SharedConstantService = inject(SharedConstantService)
  public translate: TranslateService = inject(TranslateService)

  public interventionFoodSafetyTypes = InterventionFoodSafetyTypes

  get nutrients() {
    const nutrients = this.intervention().nutrient?.nutrients ?? []

    return nutrients.map((n) => ({
      nutrient: n.nutrient,
      value: n.value,
    }))
  }
}
